import { render } from "./wordpress.vue?vue&type=template&id=4a9b59ee"
import script from "./wordpress.vue?vue&type=script&lang=js"
export * from "./wordpress.vue?vue&type=script&lang=js"

import "./wordpress.vue?vue&type=style&index=0&id=4a9b59ee&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__